import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Spinner } from '@heroui/react';
import { useAuth } from '../../hooks/useAuth';

export default function EmailVerifiedGate({ children }: { children: ReactNode }) {
  const { authUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  const isEmailProvider = authUser.providerData.some((p) => p.providerId === 'password');
  if (isEmailProvider && !authUser.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return <>{children}</>;
}
